import { useContextAppointment } from "@/modules/patients/hooks/useContextAppointment"

const CONCLUDE_COUNT_KEY = "sofia-conclude-count"

const getConcludeCountForFeedbackDialog = (): number => {
  return Number(localStorage.getItem(CONCLUDE_COUNT_KEY) ?? "1")
}

export const useIsRelevantForFeedbackDialog = () => {
  const contextAppointment = useContextAppointment()

  // Only relevant for first-time conclusion (not re-conclusion)
  const isFirstConclusion = contextAppointment?.isCompleted === false

  // Only relevant for medical appointments (not administrative)
  const isMedicalAppointment = contextAppointment?.service !== "ADMINISTRATIVE_REQUEST"

  // Feedback is not requested after follow-up appointments
  const isNotFollowUp = contextAppointment?.appointmentType !== "FOLLOW_UP"

  return isFirstConclusion && isMedicalAppointment && isNotFollowUp
}

export const incrementConcludeCountWhenRelevantForFeedbackDialog = (isRelevantForFeedbackDialog: boolean) => {
  if (!isRelevantForFeedbackDialog) {
    return
  }

  localStorage.setItem(CONCLUDE_COUNT_KEY, String(getConcludeCountForFeedbackDialog() + 1))
}

export const useShouldShowFeedbackDialog = () => {
  const isRelevantForFeedbackDialog = useIsRelevantForFeedbackDialog()

  // Only show every 5th relevant concluded appointment
  const isEveryFifthAppointment = getConcludeCountForFeedbackDialog() % 5 === 0

  return isRelevantForFeedbackDialog && isEveryFifthAppointment
}
